import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

import { isPossiblePhoneNumber } from "react-phone-number-input";

import { z } from "zod";

export const SpringAccountCreateFormSchema = z.object({
  firstName: z.string().trim().min(2),
  lastName: z.string().trim().min(2),
  emailOptIn: z.boolean(),
  phoneNum: z
    .string()
    .trim()
    .min(4)
    .refine((val) => isPossiblePhoneNumber(val, "US"), {
      error: "Enter a valid phone number.",
    }),
  //
  addr1: z.string().trim().min(2),
  addr2: z.string().trim(),
  city: z.string().trim().min(2),
  provinceCode: z.string().nonempty({ error: "Please select a valid option." }),
  zip: z.string().trim().min(2),
  country: z.string(),
  agreedToTos: z.boolean().refine((val) => val === true, {
    message: "You must agree to Mightier Terms of Service",
  }),
});

interface SpringOnboardingDataV0 {
  userCreate: z.infer<typeof SpringAccountCreateFormSchema>;
}

interface SpringOnboardingStore {
  payload: SpringOnboardingDataV0 | null;
  setPayload: (payload: SpringOnboardingDataV0) => void;
  clearPayload: () => void;
}

export const useSpringOnboardingStore = create<SpringOnboardingStore>()(
  persist(
    (set) => ({
      payload: null,
      setPayload: (payload) => set({ payload }),
      clearPayload: () => set({ payload: null }),
    }),
    {
      name: "spring-health-onboarding",
      storage: createJSONStorage(() => sessionStorage),
      version: 0,
    },
  ),
);
